var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type === 'plot')?_c('embeddable-plot',{attrs:{"url":_vm.url,"brill-image":_vm.brillImage}}):_vm._e(),_vm._v(" "),(_vm.type === 'grid')?_c('embeddable-grid',{attrs:{"url":_vm.url,"brill-image":_vm.brillImage}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }